import {combineReducers, configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';

import {authReducer} from 'app/auth/slice';

import {loadState, throttledSaveStateToLocalStorage} from '../local-storage';
import {chatSlice} from '../slice';

const reducer = combineReducers({auth: authReducer, aichat: chatSlice.reducer});

export const store = configureStore({
  reducer,
  preloadedState: loadState(),
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
});

store.subscribe(() => throttledSaveStateToLocalStorage(store));

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

setupListeners(store.dispatch);
